import React, { useState, useEffect } from "react";
import app from "../../../firebase-config";
import EstadoConfig from "../../../util/EstadoConfig.util";

function EstadoCard() {
  const [estados, setEstados] = useState([]);
  const [fecha, setFecha] = useState([]);

  async function getData() {
    await app
      .firestore()
      .collection("sensor")
      .orderBy("hora", "desc")
      .limit(3)
      .onSnapshot((snap) => {

        // ---- LIMPIAR EstadoCard primero ----
        setEstados([]);
        setFecha([]);

        const fecDocs = [];
        const docs = [];

        snap.forEach((doc) => {
          const data = doc.data();
          const hora = new Date(parseInt(data.hora));
          const diaNombreIndex = hora.getDay();

          // día de la semana
          const diaNombre =
            diaNombreIndex === 1 ? "Lunes" :
              diaNombreIndex === 2 ? "Martes" :
                diaNombreIndex === 3 ? "Miércoles" :
                  diaNombreIndex === 4 ? "Jueves" :
                    diaNombreIndex === 5 ? "Viernes" :
                      diaNombreIndex === 6 ? "Sábado" : "Domingo";

          fecDocs.push({
            mes: hora.getMonth() + 1,
            dia: hora.toLocaleDateString(),
            diaNombre,
            hora: hora.getHours(),
            minutos: hora.getMinutes(),
          });

          docs.push(data);
        });

        // Ahora recién se asignan los valores ya procesados
        setEstados(docs);
        setFecha(fecDocs);
      });
  }


  useEffect(() => {
    getData();
  }, []);

  if (estados.length < 3) return <div>Cargando...</div>;

  const actual = estados[0];
  const config = EstadoConfig[actual.estado];

  const estadoCard = (
    <div className="card card-primary card-outline">
      <div className="card-header">
        <h5 className="card-title m-0">Estado actual de tormenta</h5>
      </div>

      <div className="card-body">

        <div className="row">
          {/* ESTADO ACTUAL */}
          <div className="col-md-7 col-sm-6 col-12">
            <div
              className="small-box"
              style={{
                backgroundColor: config.color,
              }}
            >
              <div className="inner" style={{ color: "white" }}>
                <p style={{ fontSize: 35, fontWeight: "bold" }}>
                  {actual.detalle}
                </p>

                <p style={{ fontSize: 12, fontStyle: "italic" }}>
                  {actual.message}
                </p>

                <p>
                  {fecha[0].diaNombre} {fecha[0].dia}
                  <br /> A la(s) {fecha[0].hora}:{fecha[0].minutos} hrs.
                </p>
              </div>

              <div className="icon">
                <i className={`${config.icon} mt-4`} />
              </div>

              <div className="small-box-footer">
                Estado actual: {config.label}
              </div>
            </div>
          </div>

          {/* ANTERIORES */}
          <div className="col-md-5 col-sm-6 col-12">
            <div className="row">

              {/* Anterior */}
              <div className="info-box col-12">
                <span className="info-box-icon bg-info">
                  <i className="fas fa-arrow-left" />
                </span>
                <div className="info-box-content">
                  <span className="info-box-text">{estados[1].detalle}</span>
                  <span className="info-box-number">
                    {fecha[1].diaNombre} {fecha[1].dia}, {fecha[1].hora}:
                    {fecha[1].minutos} hrs.
                  </span>
                </div>
              </div>

              {/* Anterior siguiente */}
              <div className="info-box col-12">
                <span className="info-box-icon bg-info">
                  <i className="fas fa-arrow-up" />
                </span>

                <div className="info-box-content">
                  <span className="info-box-text">{estados[2].detalle}</span>
                  <span className="info-box-number">
                    {fecha[2].diaNombre} {fecha[2].dia}, {fecha[2].hora}:
                    {fecha[2].minutos} hrs.
                  </span>
                </div>
              </div>

            </div>
          </div>

        </div>
      </div>
    </div>
  );

  return estadoCard;
}

export default EstadoCard;
